"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var react_1 = __importDefault(require("react"));
var isEqualMemoize = function (value) {
    var ref = react_1.default.useRef();
    if (!isEqual_1.default(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
};
var useDeepCompareMemo = function (callback, dependencies) {
    return react_1.default.useMemo(callback, dependencies.map(isEqualMemoize));
};
exports.default = useDeepCompareMemo;
//# sourceMappingURL=index.js.map